import { openMiniCart } from "../components/miniCart";

export function productAdded(product) {
  let productAdded = document.querySelector(".product-added"),
    img = productAdded.querySelector("img"),
    title = productAdded.querySelector(".product-added__product-name"),
    viewCart = productAdded.querySelector(".product-added__button");

  let productTitle, productImage;
  if (product && typeof product === "object" && !product.querySelector) {
    productTitle = product.title;
    productImage = product.images?.[0]?.src || product.image;
  } else if (product instanceof Element) {
    productTitle = product.querySelector(".product-article__h2")
      ? product.querySelector(".product-article__h2").textContent
      : product.querySelector(".product-data__title").textContent;
    productImage = product.querySelector("img").src;
  } else {
    console.error("El formato de product no es válido.");
  }
  viewCart.addEventListener("click", () => {
    openMiniCart();
  });

  productAdded.classList.add("added");

  if (productTitle) {
    title.textContent = productTitle;
  }

  if (productImage) {
    img.src = productImage;
  }

  setTimeout(() => {
    productAdded.classList.remove("added");
  }, 3000);
}
